import { AuthoxRole } from './AuthoxRole';
/**
 * @KotlinClass com.sucsoft.organization.basic.management.commons.entity.Authoxuser
 */
export class Authoxuser {
    /**
     * @NomosDefineDescription "登录账号"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    account!: string;
    /**
     * @NomosDefineDescription "创建时间"
     * @NomosDefineType {"family":"Date","pattern":"YYYY-MM-dd"}
     * @NomosGenericElements []
     * @NomosDefineDate
     */
    createTime?: string;
    /**
     * @NomosDefineDescription ""
     * @NomosDefineType {"family":"number"}
     * @NomosGenericElements []
     */
    deleted!: number;
    /**
     * @NomosDefineDescription "描述"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    description?: string;
    /**
     * @NomosDefineDescription "显示名称"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    displayname?: string;
    /**
     * @NomosDefineDescription "组织id"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    orgId?: string;
    /**
     * @NomosDefineDescription "加密后的密码"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    password?: string;
    /**
     * @NomosDefineDescription "联系电话"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    phonemobile?: string;
    /**
     * @NomosDefineDescription "主体id"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    principalId?: string;
    /**
     * @NomosDefineDescription "角色"
     * @NomosDefineType {"family":"array","elementType":{"family":"object","className":"com.sucsoft.organization.basic.management.commons.entity.AuthoxRole","elementTypes":[]}}
     * @NomosGenericElements []
     */
    roles?: Array<AuthoxRole>;
    /**
     * @NomosDefineDescription "混淆随机数"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    salt?: string;
    /**
     * @NomosDefineDescription "用户id，主键"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    uid?: string;
    /**
     * @NomosDefineDescription "修改时间"
     * @NomosDefineType {"family":"Date","pattern":"YYYY-MM-dd"}
     * @NomosGenericElements []
     * @NomosDefineDate
     */
    updateTime?: string;
    /**
     * @NomosDefineDescription "用户信息id"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    userId?: string;
}
